// import foto1 from '../Resources/Images/foto.jpg';
import foto2 from '../Resources/Images/foto2.jpg';
// import foto3 from '../Resources/Images/foto3.jpg';
import foto5 from '../Resources/Images/foto5.jpg';
import foto7 from '../Resources/Images/foto7.jpg';
// import foto8 from '../Resources/Images/foto8.jpg';
// import foto9 from '../Resources/Images/foto9.jpg';
// import foto10 from '../Resources/Images/foto10.jpg';
import foto11 from '../Resources/Images/foto11.jpg';
import foto12 from '../Resources/Images/foto12.jpg';
import foto13 from '../Resources/Images/foto13.jpg';
import foto14 from '../Resources/Images/foto14.jpg';

export const randPhoto = () => {
  const arr = [
    foto2,
    foto5,
    foto7,
    foto11,
    foto12,
    foto13,
    foto14,
  ];
  var rand = Math.floor(Math.random() * arr.length);
  return arr[rand];
};
